// Lightweight PostHog helpers.
// All calls are no-ops if PostHog failed to load (ad-blockers, etc.),
// so callers never need to null-check window.posthog themselves.

function ph() {
  if (typeof window === 'undefined') return null;
  return window.posthog || null;
}

/**
 * Capture a custom event.
 * @param {string} event  e.g. 'user_registered'
 * @param {object} [props]
 */
export function track(event, props = {}) {
  const posthog = ph();
  if (posthog) posthog.capture(event, props);
}

/**
 * Tie the current anonymous session to a known user.
 * Safe to call repeatedly (on every page reload) — PostHog dedupes.
 */
export function identifyUser(user) {
  const posthog = ph();
  if (!posthog || !user) return;

  const id = user.id ?? user.pk ?? user.email;
  if (!id) return;

  const firstName = user.first_name ?? user.firstName;
  const lastName = user.last_name ?? user.lastName;

  posthog.identify(String(id), {
    email: user.email,
    name: [firstName, lastName].filter(Boolean).join(' ') || undefined,
    is_staff: user.is_staff ?? user.isStaff,
  });
}

/**
 * Reset identity + start a fresh anonymous session. Call on logout.
 */
export function resetAnalytics() {
  const posthog = ph();
  if (posthog) posthog.reset();
}

/**
 * Manually capture a $pageview. Used by <PostHogPageView /> to track
 * client-side route changes in this single-page app.
 */
export function capturePageview() {
  const posthog = ph();
  if (posthog) posthog.capture('$pageview');
}
